import styled from 'styled-components'

export const HomeInfoContainer = styled.div``
